import { useState, useMemo } from "react";
import Service from "./Service/Service";
import styles from "./Services.module.scss";
import { motion, AnimatePresence } from "framer-motion";

function Services(props) {
  const [showall, setShowAll] = useState(false);
  const [limit, setLimit] = useState(5);

  const sortedData = useMemo(() => {
    if (!props.data) return [];
    console.log(props.data);
    return [...props.data].sort((a, b) => {
      const orderA = parseInt(a.online_order || "999");
      const orderB = parseInt(b.online_order || "999");
      return orderA - orderB;
    });
  }, [props.data]);

  return (
    <div className={styles["services-container"]}>
      {sortedData &&
        sortedData.map((item, index) => {
          if (index === limit) {
            return (
              <button
                onClick={() => {
                  setShowAll(true);
                  setLimit(limit + 5);
                }}
                className={styles["show-more-button"]}
              >
                + Vedi altri servizi
              </button>
            );
          }
          if (index < limit) {
            return (
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
                  animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
                  transition={{ duration: 0.3 }}
                >
                  <Service
                    key={index}
                    item={item}
                    currentStep={props.currentStep}
                    selectedServices={props.selectedServices}
                    onServiceSelect={props.onServiceSelect}
                    onServiceDeSelect={props.onServiceDeSelect}
                  />
                </motion.div>
              </AnimatePresence>
            );
          }
          return <></>;
        })}
    </div>
  );
}

export default Services;
